import packageJson from '../package.json';

export const APP_VERSION = packageJson.version;

const DEFAULT_MINIMUM_API_VERSION = '5.1.299.0';

export const MINIMUM_API_VERSION =
  process.env.MINIMUM_API_VERSION ?? DEFAULT_MINIMUM_API_VERSION;

export const WORK4ALL_CUSTOMER_ID = 12345;
export const WORK4ALL_TEST_CUSTOMER_ID = 20687;
export const WORK4ALL_DEMO_CUSTOMER_ID = 28559;
export const DISABLE_SERVICE_CONTRACT_BILLING_IDS = [
  WORK4ALL_CUSTOMER_ID,
  WORK4ALL_TEST_CUSTOMER_ID,
  WORK4ALL_DEMO_CUSTOMER_ID,
];
